import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const data = [
  {
    title: "School of Science & Technology",
    courses: [
      "B.Tech in Robotics & Automation (4 Years)",
      "B.Tech in Computer Science & Cybersecurity",
      "Bachelor of Computer Application",
      "B.Sc (Hons) in Biotechnology",
      "M.Sc in Biotechnology (2 Years)",
    ],
  },
  {
    title: "School of Maritime Studies",
    courses: [
       "B.Sc in Nautical Science (3 Years)",
 "B.Tech in Marine Engineering (4 Years)",
 "Diploma in Nautical Science",
 "BBA in Shipping & Logistics",
 'MBA in Port & Shipping Management'     
    ],
  },
  {
    title: "School of Agriculture",
    courses: [
       "B.Sc (Hons) Agriculture (4 Years)",
 "B.Sc in Horticulture",
 "B.Tech in Agricultural Engineering",
 "M.Sc in Agriculture (various specializations)",
 "MBA in Agribusiness Management"
     ],
  },
   {
    title: "School of Health Sciences",
    courses: [
       "B.Sc in Medical Laboratory Technology",
 "Bachelor of Physiotherapy (BPT)",
 "B.Sc in Medical Imaging / Radiology Technology",
 "M.Sc in Clinical Nutrition & Dietetics",
 "Master of Hospital Administration (MHA)"
     
    ],
  },
   {
    title: "School of Humanities Management & Social Science",
    courses: [
       "B.A (Hons) in Psychology",
 "B.A (Hons) in Economics",
 "B.A (Hons) in Political Science / Public Administration",
"M.A in Sociology / Social Work",
 "MBA in Human Resource Management"
    ],
  },
   {
    title: "School of Legal Studies",
    courses: [
     "B.A. LL.B (Hons) – 5 Years Integrated",
 "B.B.A. LL.B (Hons) – 5 Years Integrated",
 "LL.B – 3 Years",
 "LL.M in Business / Constitutional Law",
 "Diploma / Certificate in Cyber Law & IPR"
    ],
  }
];

export default function SimpleTiltCards() {
  return (
   <section id="undergraduate" className="min-h-screen bg-[#05050f]">
        <h2 className="text-center font-bold pt-8 text-3xl text-white">UG/PG Courses</h2>
       
    <div className=" flex items-center justify-center py-20 px-6">
        
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl w-full">
          
        {data.map((item, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.08, rotateX: 6, rotateY: -6 }}
            transition={{ type: "spring", stiffness: 180, damping: 12 }}
            className="relative group p-6 rounded-2xl bg-[#181830] 
            border border-purple-500/20 shadow-xl backdrop-blur-lg cursor-pointer overflow-hidden"
          >
            {/* Glow */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700 bg-purple-500/10 blur-2xl rounded-2xl"></div>

            {/* Icon */}
            <div className="flex justify-center">
              <GraduationCap className="text-purple-300 w-12 h-12 transition-all duration-500" />
            </div>

            {/* Title */}
            <h3 className="text-center text-white text-lg font-semibold mt-4 transition-all duration-500">
              {item.title}
            </h3>

            {/* Bullet List Always Visible */}
            <ul className="list-disc text-gray-300 text-sm mt-5 space-y-1 pl-4">
              {item.courses.map((course, index) => (
                <li key={index}>{course}</li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
    </section> 
  );
}
